import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/do";
import "rxjs/add/operator/retry";
import "rxjs/add/observable/interval";
import { BaseComponent } from "@bt/core/base";

import { TokenService, Credentials } from "./token.service";
import * as moment from "moment";

import { tokenRefreshInterval } from "@bt/configs";

interface AuthData {
    accessToken: string;
    refreshToken: string;
    expiresAt: Date;
}

@Injectable()
export class AuthService extends BaseComponent{
    private static _authData: any;

    constructor(
        private cookieService: CookieService,
        private tokenService: TokenService,
        private router: Router) { 
            super();
        }

    get authData() {
        if (!AuthService._authData && this.cookieService.check("auth")) {
            AuthService._authData = JSON.parse(this.cookieService.get("auth"));
        }
        let cookAuth=!!this.cookieService.get("auth")? JSON.parse(this.cookieService.get("auth")) as AuthData : null;
        if(!!AuthService._authData && (!cookAuth || AuthService._authData.refreshToken != cookAuth.refreshToken ||
            AuthService._authData.accessToken != cookAuth.accessToken)){
            
            this.logout();
            // return;
        }
        return AuthService._authData;
    }

    set authData(newAuth: AuthData) {
        var t = this;
        if (!newAuth) {
        this.delete_cookie("auth");
        
        t.cookieService.delete("auth", "/");
        } else {
            t.cookieService.set("auth", JSON.stringify(newAuth), newAuth["expiresAt"], "/");
        }
        AuthService._authData = newAuth;
    }

    public login(credentials: Credentials) {
        return this.tokenService
            .createToken(credentials)
            .do((data) => {
                const expiresAt = moment().add(data["expires_in"], "s").toDate();
                const tokenObj: AuthData = {
                    accessToken: data["access_token"],
                    refreshToken: data["refresh_token"],
                    expiresAt
                };

                this.authData = tokenObj;
                this.initRefresh();
            });
    }

    public initRefresh() {
        if (!this.isAuth()) {
            return;
        }
        

        // Условие проверяющее сколько времени осталось у токена.
        // Если меньше 15 минут то выбрасываем на страницу логина
        // Если больше 15 минут то продолжаем
        const expiresIn = moment(this.authData.expiresAt).diff(moment(), "ms");
        if (expiresIn < tokenRefreshInterval) {
            this.logout();
            return;
        }

        Observable
            .interval(tokenRefreshInterval)
            .mergeMap(() => this.tokenService.refreshToken(this.authData.refreshToken))
            .retry(2)
            .subscribe(
                (response) => {
                    const expiresAt = moment().add(response["expires_in"], "s").toDate();
                    const tokenObj: AuthData = {
                        accessToken: response["access_token"],
                        refreshToken: response["refresh_token"],
                        expiresAt
                    };
                    this.authData = tokenObj;
                },
                (error) => {
                    this.logout();
                }
            );

    }

    public isAuth() {
        return !!this.authData;
    }

    public delete_cookie( name ) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
    public clearAuth(){
        this.authData = undefined;
        this.delete_cookie("auth");
    }

    public logout() {
        window.stop();
        this.setLoading(false);
        this.authData = undefined;
        this.router.navigateByUrl("login");
        return;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/auth.service.ts